export default "__VITE_ASSET__uZl0tJCm__"